import { resolveEffectivePermissions } from '@/modules/common/permissions/permissionPreview';
import { resolveGrants, resolveLayout } from '@/modules/common/permissions/permissionRegistry';
import { CurrentUser } from '@/modules/infrastructure/users/types/user.types';

/**
 * Ключи доступа собираются из разрешений позиции: см. PERMISSION_LAYOUTS.
 * Пока бэкенд права не отдаёт, список пуст и выдаётся полный набор ключей —
 * так интерфейс не прячет разделы у тех, кому права ещё не раздали.
 *
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(initialState: { currentUser?: CurrentUser } | undefined) {
  const { currentUser } = initialState ?? {};
  if (!currentUser) {
    return { canAdmin: false };
  }
  const { permissions } = resolveEffectivePermissions(currentUser.permissions);
  return resolveGrants(resolveLayout(permissions));
}
